// utility contexts to hold Create Account specific global values
import { createContext, useContext } from 'react';

let createAccountContext = null;

// FYI:
// createAccountContext schema:
// {
//     "title": "createAccountContext",
//     "type": "object",
//     "properties": {
//         "joinType": {
//             "type": "string",
//             "description": "possible values: JoinToMerge, JoinFromGuid, Join"
//         },
//         "thirdPartyUserName": {
//             "type": "string",
//             "description": "default username from third-party login"
//         }
//     }
// }

export function SetCreateAccountContext(joinType, thirdPartyUserName) {
    const createAccount = { "joinType": joinType, "thirdPartyUserName": thirdPartyUserName };

    createAccountContext = createContext(createAccount);
    return createAccountContext;
}

export function useCreateAccountContext() {
    return useContext(createAccountContext);
}
